import requests from "./httpService";
// const adminInfo = localStorage.getItem("adminInfo")
//   ? JSON.parse(localStorage.getItem("adminInfo"))
//   : null;
// const id_employee = adminInfo?.id ? adminInfo.id : 0;
const ChatServices = {
  // goOnline (PUT /users/online-status) removed — Online/Offline is socket-only.

  getDashboardCount: async (id_employee) => {
    return requests.get(`/dashboardCount/${id_employee}`);
  },

  savePushSubscription: async (subscription) => {
    return requests.post(`/push/subscribe`, { subscription });
  },

  deletePushSubscription: async (endpoint) => {
    // requests.delete forwards its 2nd arg straight through as axios config,
    // not as the request body — axios needs { data: {...} } for a DELETE body.
    return requests.delete(`/push/subscribe`, { data: { endpoint } });
  }


};

export default ChatServices;
